'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M117.7 343.9c.9 3.5 2.6 7.2 5.2 11.3L311.9 166.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7.9 7.9 87.2 0c2.5-6.7 4.8-13.4 7.1-20.1 16.7-50.6 26-100.7 30.2-138.3-37.6 4.3-87.7 13.6-138.2 30.2-59.1 19.5-114.7 47.6-152.8 85.7-65.3 65.3-64.9 136.9-53.7 178.3zm39.1 45.2c4.1 2.6 7.9 4.2 11.3 5.2 38.9 10.5 104.3 11.6 166.2-42.3l-140.4 0-37.2 37.2zM242 304l134.8 0c10.2-14.8 19.6-31 27.9-48l-114.7 0-48 48z', 'M475.3 .1c9.9-.8 19.6 3 26.6 10s10.8 16.7 10 26.6l-1.6 16.6c-9.7 87.2-44.5 235.8-129.9 321.3l-7.5 7.3c-73.1 68.1-153.7 72.6-206.7 61.3l-10.6-2.5c-12.2-3.3-23.2-9.5-33.3-17.1L41 505c-9.4 9.4-24.6 9.4-33.9 0S-2.3 480.4 7 471l81.3-81.4c-6-8-11.2-16.5-14.7-25.9l-2.4-7.3C57.2 304 57.3 217.3 130.1 139.2l7.3-7.5C228.5 40.5 391.6 7 475.3 .1zM194 352l-37.2 37.2c4.1 2.6 7.9 4.2 11.3 5.2 38.9 10.5 104.3 11.6 166.2-42.3L194 352zM462.4 49.6c-37.6 4.3-87.7 13.6-138.2 30.2-59.1 19.5-114.7 47.6-152.8 85.7-65.3 65.3-64.9 136.9-53.7 178.3 .9 3.5 2.6 7.2 5.2 11.3L311.9 166.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7.9 7.9 87.2 0c2.5-6.7 4.8-13.4 7.1-20.1 16.7-50.6 26-100.7 30.2-138.3zM289.9 256l-48 48 134.8 0c10.2-14.8 19.6-31 27.9-48l-114.7 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;